import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import Page from '../Page';
import PageSection from '../PageSection';
import ThankYou from '../ThankYou';

import logo from '../../assets/images/global/seakeeper-logo-only.svg';

class SizingFormConfigured extends Component {

	render() {

		var title = <span>Thank you for submitting a Seakeeper <br />Sizing Form &amp; Gyro Configuration!</span>,
			message = <span>We’ll notify you with any updates or when an Administrator has <br />approved the report. You can check its status on your <a href="/dashboard">Dashboard</a>.</span>;

		return (
			<Page pageClass="pp-sizing-form-thank-you-page">
				<ThankYou
					icon={logo}
				 	title={title}
					message={message}
				/>
			</Page>
		);
	}
}

export default SizingFormConfigured;



// WEBPACK FOOTER //
// ./src/components/pages/SizingFormConfigured.js